import { MAX_CORRIDOR_METRES, MAX_MOVEMENT_MINUTES } from '@chukua/common';
import { Form, InputNumber, Switch } from 'antd';

function NudgeDriverField() {
  return (
    <Form.Item
      name="nudgeDriver"
      label="Also ask the driver to check their steps"
      valuePropName="checked"
      extra="Sends the driver a push notification (never an SMS) when this alert is raised. Off unless you turn it on."
    >
      <Switch />
    </Form.Item>
  );
}

/** A stop GPS saw the truck at, with no tap from the driver. Judged against the stops of the trip's plan. */
export function MilestoneMissingFields() {
  return (
    <>
      <Form.Item
        name="windowMinutes"
        label="No tap within (minutes of GPS arriving or leaving)"
        extra="A tap that arrives later, for example after the phone reconnects, closes the alert by itself."
        rules={[{ required: true, type: 'number', min: 1, max: MAX_MOVEMENT_MINUTES, message: `Enter 1 to ${MAX_MOVEMENT_MINUTES} minutes` }]}
      >
        <InputNumber min={1} max={MAX_MOVEMENT_MINUTES} className="w-32" />
      </Form.Item>
      <NudgeDriverField />
    </>
  );
}

/** A tap made far from the stop it names, by the GPS fixes around the moment of the tap. */
export function MilestoneFarFields() {
  return (
    <>
      <Form.Item
        name="distanceMetres"
        label="Tap is farther from the stop than (metres)"
        extra="Measured to the centre of the stop's zone, so a large yard needs a larger distance."
        rules={[{ required: true, type: 'number', min: 50, max: MAX_CORRIDOR_METRES, message: `Enter 50 to ${MAX_CORRIDOR_METRES} metres` }]}
      >
        <InputNumber min={50} max={MAX_CORRIDOR_METRES} className="w-32" />
      </Form.Item>
      <Form.Item
        name="aroundMinutes"
        label="Using GPS fixes within (minutes either side of the tap)"
        extra="If any fix in this window is near the stop, the tap is fine. With no fixes in the window, nothing is raised."
        rules={[{ required: true, type: 'number', min: 1, max: 60, message: 'Enter 1 to 60 minutes' }]}
      >
        <InputNumber min={1} max={60} className="w-32" />
      </Form.Item>
      <NudgeDriverField />
    </>
  );
}
